'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _util = require('./util');

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var RequestBuilder = function () {
    function RequestBuilder(fetchJsonClient) {
        _classCallCheck(this, RequestBuilder);

        this.client = fetchJsonClient;
        this.transformers = [];
    }

    _createClass(RequestBuilder, [{
        key: 'asDelete',
        value: function asDelete() {
            return this._addTransformer(function (input, init) {
                init.method = 'DELETE';
            });
        }
    }, {
        key: 'asGet',
        value: function asGet() {
            return this._addTransformer(function (input, init) {
                init.method = 'GET';
            });
        }
    }, {
        key: 'asPut',
        value: function asPut() {
            return this._addTransformer(function (input, init) {
                init.method = 'PUT';
            });
        }
    }, {
        key: 'asPost',
        value: function asPost() {
            return this._addTransformer(function (input, init) {
                init.method = 'POST';
            });
        }
    }, {
        key: 'asPatch',
        value: function asPatch() {
            return this._addTransformer(function (input, init) {
                init.method = 'PATCH';
            });
        }
    }, {
        key: 'withUrl',
        value: function withUrl(url) {
            return this._addTransformer(function (input, init) {
                input[1] = url;
            });
        }
    }, {
        key: 'withBaseUrl',
        value: function withBaseUrl(baseUrl) {
            return this._addTransformer(function (input, init) {
                input[0] = baseUrl;
            });
        }
    }, {
        key: 'withHeader',
        value: function withHeader(key, value) {
            return this._addTransformer(function (input, init) {
                init.headers = init.headers || {};
                init.headers[key] = value;
            });
        }
    }, {
        key: 'withBody',
        value: function withBody(body) {
            if (body) {
                return this._addTransformer(function (input, init) {
                    init.body = (0, _util.json)(body);
                });
            } else {
                return this;
            }
        }
    }, {
        key: 'withMode',
        value: function withMode(mode) {
            if (['cors', 'no-cors', 'same-origin', 'navigate'].includes(mode)) {} else {
                if (mode) {
                    console.warn('bad mode passed, switching to same-origin');
                }
                mode = 'same-origin';
            }
            return this._addTransformer(function (input, init) {
                init.mode = mode;
            });
        }
    }, {
        key: 'withCredentials',
        value: function withCredentials(credentials) {
            if (['omit', 'include', 'same-origin'].indexOf(credentials) > 0) {} else {
                if (credentials) {
                    console.warn('bad credentials mode passed, switching to same-origin');
                }
                credentials = 'same-origin';
            }
            return this._addTransformer(function (input, init) {
                init.credentials = credentials;
            });
        }

        // -- no ops --

    }, {
        key: 'withCache',
        value: function withCache() {
            return this;
        }
    }, {
        key: 'withRedirect',
        value: function withRedirect() {
            return this;
        }
    }, {
        key: 'withReferrer',
        value: function withReferrer() {
            return this;
        }
    }, {
        key: 'withIntegrity',
        value: function withIntegrity() {
            return this;
        }
        // -- no ops --

    }, {
        key: '_addTransformer',
        value: function _addTransformer(fn) {
            this.transformers.push(fn);
            return this;
        }
    }, {
        key: '_resolveTransformers',
        value: function _resolveTransformers() {
            var input = [];
            var init = {};
            // configuration via createRequest
            for (var i = 0, ii = this.transformers.length; i < ii; ++i) {
                this.transformers[i](input, init);
            }
            // configuration via configure
            for (var _i = 0, _ii = this.client.requestTransformers.length; _i < _ii; ++_i) {
                this.client.requestTransformers[_i](input, init);
            }
            // set url
            input = input.join('');
            return { input: input, init: init };
        }
    }, {
        key: 'send',
        value: function send() {
            var _resolveTransformers2 = this._resolveTransformers(),
                input = _resolveTransformers2.input,
                init = _resolveTransformers2.init;

            var request = new Request(input, init);
            return this.client.send(request);
        }
    }]);

    return RequestBuilder;
}();

exports.default = RequestBuilder;


//////////////////
// WEBPACK FOOTER
// ./node_modules/fetch-json-client/dist/lib/request-builder.js
// module id = 648
// module chunks = 0